import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { fetchSubscriptionList } from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";

const ListSubscriptions = () => {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetchSubscriptionList();
        setSubs((response.data || []).sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        )
        );
      } catch (err) {
        toast.error("Failed to load subscriptions.");
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "subscription_type", headerName: "Type", width: 150 },
    {
      field: "created_at",
      headerName: "Subscribed On",
      width: 180,
      renderCell: (params) => new Date(params.value).toLocaleString("en-IN"),
    },
  ];

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>Subscription List</Typography>
      {loading ? <CircularProgress /> : <DataGrid rows={subs} columns={columns} autoHeight getRowId={(row) => row.id} />}
    </Box>
  );
};

export default ListSubscriptions;